import { render, staticRenderFns } from "./CreatedGroupDialog.vue?vue&type=template&id=77491020&scoped=true&"
import script from "./CreatedGroupDialog.vue?vue&type=script&lang=js&"
export * from "./CreatedGroupDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreatedGroupDialog.vue?vue&type=style&index=0&id=77491020&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77491020",
  null
  
)

export default component.exports